import { Injectable } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute, Params } from '@angular/router';
import { filter } from 'rxjs/operators';

export interface RouteHistoryEntry {
  url: string;
  params: Params;
  queryParams: Params;
}

@Injectable({
  providedIn: 'root'
})
export class RouteHistoryService {
  private history: RouteHistoryEntry[] = [];
  private maxHistory = 20;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const route = this.getDeepestChild(this.activatedRoute);

        this.addRoute({
          url: event.urlAfterRedirects,
          params: route.snapshot.params,
          queryParams: route.snapshot.queryParams
        });
      });
  }

  private getDeepestChild(route: ActivatedRoute): ActivatedRoute {
    let currentRoute = route;
    while (currentRoute.firstChild) {
      currentRoute = currentRoute.firstChild;
    }
    return currentRoute;
  }

  private addRoute(entry: RouteHistoryEntry): void {
    this.history.push(entry);

    if (this.history.length > this.maxHistory) {
      this.history.shift();
    }
  }

  getHistory(): RouteHistoryEntry[] {
    return [...this.history];
  }

  getPreviousRoute(): RouteHistoryEntry | null {
    return this.history.length > 1
      ? this.history[this.history.length - 2]
      : null;
  }

  getPreviousUrl(): string | null {
    const previous = this.getPreviousRoute();
    return previous ? previous.url : null;
  }

  getLastMatchingRoute(fragment: string): RouteHistoryEntry | null {
    for (let i = this.history.length - 1; i >= 0; i--) {
      const entry = this.history[i];

      if (entry.url.includes(fragment)) {
        return entry;
      }
    }

    return null;
  }

  clear(): void {
    this.history = [];
  }
}
